module.exports = __webpack_public_path__ + "media/application/images/svgs/printer-bd25144c879cdc004bed9c43b9d5dbe5.svg";